import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';

const AppFooter = ({
  resultsCount,
  resultsAmountTotal,
  isSearchPage,
  filteredResultsCount,
  showAppContent,
}) => {
  // Links in footer
  const POLICY_LINK = 'https://www.apexclearing.com/privacy-policy/';
  const OTHER_DISCLOSURES_LINK = 'https://www.apexclearing.com/disclosures/';
  const FUTURE_DISCLOSURES_LINK = 'https://www.apexclearing.com/futures-disclosures/';
  const PRESS_LINK = 'https://www.apexclearing.com/newsroom/';

  return (
    <nav className={styles.appFooter} >
      {showAppContent && isSearchPage && resultsCount && (
        <div className={styles['appFooter-search']} data-test-handle="results-bar">
          <span className={styles['appFooter-search__amounts']} data-test-handle="results-count">
            <FormattedMessage {...messages.resultsCount} />: {filteredResultsCount} <FormattedMessage {...messages.of} /> {resultsCount}
          </span>
          <span className={styles['appFooter-search__amounts']} data-test-handle="results-amount-total">
            <FormattedMessage {...messages.resultsAmountTotal} />: {resultsAmountTotal}
          </span>
        </div>
      )}
      <div className={styles['appFooter-registered']}>
        <FormattedMessage {...messages.registered} /> <a href="http://www.finra.org/brokercheck">http://www.finra.org/brokercheck</a>
      </div>
      <div className={styles['appFooter-links']}>
        <div className={styles['appFooter-links--item']}><a href={POLICY_LINK}><FormattedMessage {...messages.policy} /></a></div>
        <div className={styles['appFooter-links--item']}><a href={OTHER_DISCLOSURES_LINK}><FormattedMessage {...messages.other} /></a></div>
        <div className={styles['appFooter-links--item']}><a href={FUTURE_DISCLOSURES_LINK}><FormattedMessage {...messages.futures} /></a></div>
        <div className={styles['appFooter-links--item']}><a href={PRESS_LINK}><FormattedMessage {...messages.press} /></a></div>
      </div>
      <div className={styles['appFooter-black']}>
        <div className="copy-right">
          © {new Date().getFullYear()} <FormattedMessage {...messages.copyright} />
        </div>
        <div className="app-version">
          <FormattedMessage {...messages.member} /> | ver {VERSION}
        </div>
      </div>
    </nav >
  );
};

AppFooter.propTypes = {
  resultsCount: PropTypes.number.isRequired,
  filteredResultsCount: PropTypes.number.isRequired,
  resultsAmountTotal: PropTypes.string.isRequired,
  showAppContent: PropTypes.bool.isRequired,
  isSearchPage: PropTypes.bool,
};

AppFooter.defaultProps = {
  isSearchPage: false,
};

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppFooter/index.js